import { BoardModel } from "./BoardModel";
import { BlockViewModel } from "../Board";

export const moveSideways = (boardModel: BoardModel, currentBlock: BlockViewModel, direction: number) => {
  const newX = currentBlock.x + direction;
  if (boardModel.doesBlockFit(newX, currentBlock.y, currentBlock.block)) {
    currentBlock.x = newX;
    return true; 
  } else {
    return false;
  }
};

export const rotateBlock = (boardModel: BoardModel, currentBlock: BlockViewModel) => {
  const newBlockViewModel = {...currentBlock, block: currentBlock.block.rotate()};
  if (boardModel.doesBlockFit(newBlockViewModel.x, newBlockViewModel.y, newBlockViewModel.block)) {
    return newBlockViewModel;
  } else {
    return undefined;
  }
}

export const zoomDown = (boardModel: BoardModel, currentBlock: BlockViewModel) => {
  let newY = currentBlock.y;
  do {
    newY += 1;
  } while(boardModel.doesBlockFit(currentBlock.x, newY, currentBlock.block));
  currentBlock.y = newY - 1;
};

export const stepDown = (boardModel: BoardModel, currentBlock: BlockViewModel) => {
  const newY = currentBlock.y + 1;
  if (boardModel.doesBlockFit(currentBlock.x, newY, currentBlock.block)) {
    currentBlock.y = newY;
    return false; // not locked
  } else {
    boardModel.placeBlock(currentBlock.x, currentBlock.y, currentBlock.block);
    return true; // locked
  }
};
